import { useMatches, type UIMatch } from 'react-router';

type CrumbHandle = {
    crumb?: React.ReactNode;
    crumbText?: string;
};

export default function PageTitle() {
    const matches = useMatches() as UIMatch<any, CrumbHandle>[];

    const breadCrumbMatched = matches.filter(match => match.handle?.crumb || match.handle?.crumbText);
    const last = breadCrumbMatched[breadCrumbMatched.length - 1]?.handle;
    const lastLabel =
        typeof last?.crumb === 'string' ? last.crumb : typeof last?.crumbText === 'string' ? last.crumbText : null;
    const title = lastLabel ? `${lastLabel} | The Patient Journey` : 'The Patient Journey';

    return <title>{title}</title>;
}
